module.exports = __webpack_public_path__ + "media/packs/images/flags/AZ-79fa413141c2f88e7f262f13f295c18b.png";